import React, { useState } from "react";
import { useData } from "../../context/DataContext";
import { successToast, errorToast } from "../../utils/dialog";

export default function AdminContactManager() {
  const { contactSectionContent, updateContactSectionContent, contactFormSubmissions } = useData();
  const [formData, setFormData] = useState(contactSectionContent);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateContactSectionContent(formData);
      successToast("Contact section updated.");
    } catch (error) {
      console.error("Error updating contact section content:", error);
      errorToast("An error occurred. Please try again.");
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-8">
      <h2 className="text-2xl font-bold text-gray-800">Manage Contact Section</h2>

      {/* Form to Update Contact Section Content */}
      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded-lg shadow-md">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            placeholder="Enter Title"
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            placeholder="Enter Address"
            rows={3}
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            placeholder="Enter Phone Number"
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Enter Email"
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
        >
          Update Content
        </button>
      </form>

      {/* Display Contact Form Submissions */}
      <div>
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Contact Form Submissions</h3>
        <div className="space-y-4">
          {contactFormSubmissions.map((submission) => (
            <div
              key={submission.id}
              className="bg-white p-4 rounded-lg shadow-md border border-gray-200"
            >
              <p className="text-sm text-gray-700">
                <strong>Name:</strong> {submission.name}
              </p>
              <p className="text-sm text-gray-700">
                <strong>Email:</strong> {submission.email}
              </p>
              <p className="text-sm text-gray-700">
                <strong>Phone:</strong> {submission.phone}
              </p>
              <p className="text-sm text-gray-700">
                <strong>Message:</strong> {submission.message}
              </p>
              <p className="text-xs text-gray-500">
                <strong>Submitted At:</strong> {new Date(submission.createdAt).toLocaleString()}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}